// TOP LEVEL IMPORTS
import React from 'react';
import { ThemeProvider } from 'styled-components';
// LIB
import theme from 'lib/theme';
// APOLLO
import client from 'ApolloClient';
import { ApolloProvider } from 'react-apollo';

// COMPONENTS
import AppRoutes from 'routes';
import { StripeProvider } from 'react-stripe-elements';

const { REACT_APP_STRIPE_PUBLISHABLE_KEY } = process.env;

export default () => (
  <ApolloProvider client={client}>
    <ThemeProvider theme={theme}>
      <StripeProvider apiKey={REACT_APP_STRIPE_PUBLISHABLE_KEY}>
        <AppRoutes theme={theme} />
      </StripeProvider>
    </ThemeProvider>
  </ApolloProvider>
);



// WEBPACK FOOTER //
// ./src/App.js